export class KidsThemeActor {

	/**
 	* @param theme {tlc.ls2kids.themes.BaseTheme} the theme
	* @param type {string} the kind of Actor to create, like a cloud, grass, sun, cloud
	* @constructor
	* @param options
	*/
	constructor(theme, type, options) {
		options = options || {};
		this.type = type;
		this.theme = theme;
		this.options = options;
		this.genericActorClass = 'genericActor';

		this.parentElement = this.theme.element;

		this.add();
	}
	add() {
		this.element = $('<div></div>')
			.addClass(this.type)
			.addClass(this.genericActorClass)
			.appendTo(this.parentElement);

		if (typeof this.options.image === 'string') {
			this.element.append(
				this.getImage()
			);
		}

		if (typeof this.options.css === 'object') {
			this.element.css(this.options.css);
		}

		if (this.options.wrap) {
			this.element.wrap('<div class="' + this.options.wrap + '"></div>');
		}
	}
	getImage() {
		var imagePath = this.theme.imagesPath + '/' + this.options.image;

		return '<img width="100%" role="presentation" src="' + imagePath + '" alt="" />';
	}
}



